export default ($) => {
    let loadMoreSearch = $('.js-loadmore-search');
    let parent = loadMoreSearch.parent();
    loadMoreSearch.click(function() {
        var scrollPosition = $(window).scrollTop();

        var button = $(this),
            data = {
                'action': 'loadmore_search',
                'query': wp_params.posts,
                'page' : wp_params.current_page
            };

        $.ajax({
            url : wp_params.ajaxurl,
            data : data,
            type : 'POST',
            beforeSend : function () {
                button.text('Loading...');
                button.attr('disabled', true);
            },
            success : function(data) {
                if (data) {
                    button.text( 'Load More' ).attr('disabled', false);
                    parent.before(data);
                    wp_params.current_page++;
                    $(window).scrollTop(scrollPosition);

                    if (wp_params.current_page == wp_params.max_page)
                        parent.remove();

                    // you can also fire the "post-load" event here if you use a plugin that requires it
                    // $( document.body ).trigger( 'post-load' );
                } else {
                    parent.remove();
                }
            }
        });
    });
}